import { __awaiter, __generator } from "tslib";
import { fetchManyEntities } from './http/fetch-many-entities';
export var fetchProducts = function (productIds, includeType) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchManyEntities(productIds, "p" /* Product */, includeType)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
